import { createReducer } from "redux-act";

import {
  // EasyInvest
  REQAnalyticList, RESAnalyticList, FailAnalyticList, CleanUpAnalyticList,
  // UntHld
  REQAnalyticUntHldList, RESAnalyticUntHldList, FailAnalyticUntHldList, CleanUpAnalyticUntHldList,
  // PVD
  REQAnalyticPVDList, RESAnalyticPVDList, FailAnalyticPVDList, CleanUpAnalyticPVDList,
  // PVD Excel Download
  REQAnalyticPVDExcelDownload, RESAnalyticPVDExcelDownload, FailAnalyticPVDExcelDownload,
  PROGRESSAnalyticPVDExcelDownload, CleanUpAnalyticPVDExcelDownload
} from "./actions";

const initialState = {
  // EasyInvest
  REQStrAnalyticList: false,
  AnalyticList: [],

  // UntHld
  REQStrAnalyticUntHldList: false,
  AnalyticUntHldList: [],

  // PVD
  REQStrAnalyticPVDList: false,
  AnalyticPVDList: [],

  // PVD Excel Download
  REQStrAnalyticPVDExcelDownload: false,
  AnalyticPVDExcelDownload: [],
  AnalyticPVDExcelProgress: null
};


const analyticListReducer = createReducer(
  {
    // EasyInvest
    [REQAnalyticList]: (state) => ({ ...state, REQStrAnalyticList: true }),
    [RESAnalyticList]: (state, payload) => ({ ...state, REQStrAnalyticList: false, AnalyticList: payload }),
    [FailAnalyticList]: (state) => ({ ...state, REQStrAnalyticList: false, AnalyticList: [] }),
    [CleanUpAnalyticList]: () => initialState,

    // UntHld
    [REQAnalyticUntHldList]: (state) => ({ ...state, REQStrAnalyticUntHldList: true }),
    [RESAnalyticUntHldList]: (state, payload) => ({ ...state, REQStrAnalyticUntHldList: false, AnalyticUntHldList: payload }),
    [FailAnalyticUntHldList]: (state) => ({ ...state, REQStrAnalyticUntHldList: false, AnalyticUntHldList: [] }),
    [CleanUpAnalyticUntHldList]: () => initialState,

    // PVD
    [REQAnalyticPVDList]: (state) => ({ ...state, REQStrAnalyticPVDList: true }),
    [RESAnalyticPVDList]: (state, payload) => ({ ...state, REQStrAnalyticPVDList: false, AnalyticPVDList: payload }),
    [FailAnalyticPVDList]: (state) => ({ ...state, REQStrAnalyticPVDList: false, AnalyticPVDList: [] }),
    [CleanUpAnalyticPVDList]: () => initialState,

    // PVD Excel Download
    [REQAnalyticPVDExcelDownload]: (state) => ({ ...state, REQStrAnalyticPVDExcelDownload: true, AnalyticPVDExcelDownload: [], AnalyticPVDExcelProgress: null }),
    [PROGRESSAnalyticPVDExcelDownload]: (state, payload) => ({ ...state, AnalyticPVDExcelProgress: payload }),
    [RESAnalyticPVDExcelDownload]: (state, payload) => ({ ...state, REQStrAnalyticPVDExcelDownload: false, AnalyticPVDExcelDownload: payload, AnalyticPVDExcelProgress: null }),
    [FailAnalyticPVDExcelDownload]: (state) => ({ ...state, REQStrAnalyticPVDExcelDownload: false, AnalyticPVDExcelDownload: [], AnalyticPVDExcelProgress: null }),
    [CleanUpAnalyticPVDExcelDownload]: (state) => ({ ...state, AnalyticPVDExcelDownload: [], AnalyticPVDExcelProgress: null })
  },
  initialState
);

export default analyticListReducer;